var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.company
    ? _c(
        "form",
        {
          on: {
            submit: function($event) {
              $event.stopPropagation()
              $event.preventDefault()
              return _vm.onSubmit.apply(null, arguments)
            }
          }
        },
        [
          _c("messages", { attrs: { messages: _vm.messages } }),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-md-12 container-adduser" },
              [
                _vm.$userIsSuperAdmin()
                  ? [
                      _c(
                        "div",
                        { staticClass: "form-row" },
                        [
                          _c(
                            "b-form-group",
                            {
                              staticClass: "input-group col-md-6",
                              attrs: {
                                label: "Status",
                                "label-for": _vm.getId("status_id"),
                                state: _vm.fieldState("status_id"),
                                "invalid-feedback": _vm.invalidField(
                                  "status_id"
                                )
                              }
                            },
                            [
                              _c(
                                "b-form-select",
                                {
                                  staticClass: "form-control",
                                  attrs: {
                                    id: _vm.getId("status_id"),
                                    disabled: !_vm.$userIsSuperAdmin()
                                  },
                                  model: {
                                    value: _vm.company.status_id,
                                    callback: function($$v) {
                                      _vm.$set(_vm.company, "status_id", $$v)
                                    },
                                    expression: "company.status_id"
                                  }
                                },
                                [
                                  _c("option", { domProps: { value: 1 } }, [
                                    _vm._v("Active")
                                  ]),
                                  _vm._v(" "),
                                  _vm.company.status_id === 2
                                    ? _c("option", { domProps: { value: 2 } }, [
                                        _vm._v("Preview")
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("option", { domProps: { value: 4 } }, [
                                    _vm._v("Blocked")
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { domProps: { value: 3 } }, [
                                    _vm._v("Stock only")
                                  ])
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            {
                              staticClass: "input-group col-md-6",
                              attrs: {
                                label: "Stop Credit",
                                "label-for": _vm.getId("stop_credit"),
                                state: _vm.fieldState("stop_credit"),
                                "invalid-feedback": _vm.invalidField(
                                  "stop_credit"
                                )
                              }
                            },
                            [
                              _c("b-form-checkbox", {
                                attrs: {
                                  id: _vm.getId("stop_credit"),
                                  state: _vm.fieldState("stop_credit"),
                                  value: 1,
                                  "unchecked-value": 0
                                },
                                model: {
                                  value: _vm.company.stop_credit,
                                  callback: function($$v) {
                                    _vm.$set(_vm.company, "stop_credit", $$v)
                                  },
                                  expression: "company.stop_credit"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-row" },
                        [
                          _c(
                            "b-form-group",
                            {
                              staticClass: "input-group col-md-6",
                              attrs: {
                                label: "Notes",
                                "label-for": _vm.getId("notes"),
                                state: _vm.fieldState("notes"),
                                "invalid-feedback": _vm.invalidField("notes")
                              }
                            },
                            [
                              _c("b-form-textarea", {
                                attrs: {
                                  id: _vm.getId("notes"),
                                  state: _vm.fieldState("notes"),
                                  rows: 6,
                                  placeholder: "Enter notes"
                                },
                                model: {
                                  value: _vm.company.notes,
                                  callback: function($$v) {
                                    _vm.$set(_vm.company, "notes", $$v)
                                  },
                                  expression: "company.notes"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-row" },
                  [
                    _c(
                      "b-form-group",
                      {
                        staticClass: "input-group col-md-6",
                        attrs: {
                          label: "Name",
                          "label-for": _vm.getId("name"),
                          state: _vm.fieldState("name"),
                          "invalid-feedback": _vm.invalidField("name")
                        }
                      },
                      [
                        _c("b-form-input", {
                          attrs: {
                            id: _vm.getId("name"),
                            type: "text",
                            state: _vm.fieldState("name"),
                            placeholder: "Enter name"
                          },
                          model: {
                            value: _vm.company.name,
                            callback: function($$v) {
                              _vm.$set(_vm.company, "name", $$v)
                            },
                            expression: "company.name"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-form-group",
                      {
                        staticClass: "input-group col-md-6",
                        attrs: {
                          label: "Website",
                          "label-for": _vm.getId("website"),
                          state: _vm.fieldState("website"),
                          "invalid-feedback": _vm.invalidField("website")
                        }
                      },
                      [
                        _c("b-form-input", {
                          attrs: {
                            id: _vm.getId("website"),
                            type: "text",
                            state: _vm.fieldState("website"),
                            placeholder: "Enter website"
                          },
                          model: {
                            value: _vm.company.website,
                            callback: function($$v) {
                              _vm.$set(_vm.company, "website", $$v)
                            },
                            expression: "company.website"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-row" },
                  [
                    _c(
                      "b-form-group",
                      {
                        staticClass: "input-group col-md-6",
                        attrs: {
                          label: "Phone",
                          "label-for": _vm.getId("phone_number"),
                          state: _vm.fieldState("phone_number"),
                          "invalid-feedback": _vm.invalidField("phone_number")
                        }
                      },
                      [
                        _c("b-form-input", {
                          attrs: {
                            id: _vm.getId("phone_number"),
                            type: "text",
                            state: _vm.fieldState("phone_number"),
                            placeholder: "Enter phone"
                          },
                          model: {
                            value: _vm.company.phone_number,
                            callback: function($$v) {
                              _vm.$set(_vm.company, "phone_number", $$v)
                            },
                            expression: "company.phone_number"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-row" },
                  [
                    _c(
                      "b-form-group",
                      {
                        staticClass: "input-group col-md-6",
                        attrs: {
                          label: "Address",
                          "label-for": _vm.getId("address"),
                          state: _vm.fieldState("address"),
                          "invalid-feedback": _vm.invalidField("address")
                        }
                      },
                      [
                        _c("b-form-textarea", {
                          attrs: {
                            id: _vm.getId("address"),
                            state: _vm.fieldState("address"),
                            rows: 6,
                            placeholder: "Enter address"
                          },
                          model: {
                            value: _vm.company.address,
                            callback: function($$v) {
                              _vm.$set(_vm.company, "address", $$v)
                            },
                            expression: "company.address"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              2
            ),
            _vm._v(" "),
            _c("div", { staticClass: "form-row" }, [
              _c(
                "div",
                { staticClass: "form-group col-md-6" },
                [
                  _c(
                    "b-btn",
                    { staticClass: "btn", attrs: { type: "submit" } },
                    [_vm._v("Save")]
                  )
                ],
                1
              )
            ])
          ])
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-57caa3e4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57caa3e4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Companies/EditCompany.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-57caa3e4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Companies/EditCompany.vue
// module chunks = 0